import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import sanityClient from "../../sanityClient";
import NewsletterSignup from "../../components/NewsletterSignup";

const HabitatHappenings = () => {
  const [newsletters, setNewsletters] = useState([]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "habitatHappenings"] | order(publishedAt desc) {
          _id,
          title,
          description,
          publishedAt,
          "pdfUrl": pdf.asset->url
        }`
      )
      .then((data) => setNewsletters(data))
      .catch(console.error);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Habitat Happenings Newsletter - Habitat for Humanity Buffalo
        </title>
        <meta
          name="description"
          content="Stay updated with Habitat Happenings, the newsletter from Habitat for Humanity Buffalo, featuring the latest news, updates, and stories from our community."
        />
      </Helmet>
      <Container>
        <h1>Habitat Happenings Newsletter</h1>
        {newsletters.length > 0 ? (
          newsletters.map((newsletter) => (
            <Newsletter key={newsletter._id}>
              <h2>{newsletter.title}</h2>
              <p>{new Date(newsletter.publishedAt).toDateString()}</p>
              <p>{newsletter.description}</p>
              <ReadMoreButton
                href={newsletter.pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Read More
              </ReadMoreButton>
            </Newsletter>
          ))
        ) : (
          <p>No newsletters available.</p>
        )}
        <NewsletterSignup />
      </Container>
    </>
  );
};
const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const Newsletter = styled.div`
  margin-bottom: 40px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;

  h2 {
    color: var(--primary-color);
    margin-bottom: 10px;
  }

  p {
    margin: 5px 0 15px;
    color: #666;
  }
`;

const ReadMoreButton = styled.a`
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    background-color: var(--accent-color);
  }
`;

export default HabitatHappenings;
